import type * as api from '@gitbook/api-client';
import type { IconName as FAIconName } from '@gitbook/icons';
import { Icon } from '@gitbook/spine-icons';

import { ContentIcon } from '../Icons';

export function SiteSectionIcon(props: {
    siteSection: api.SiteSection;
    size?: number;
    className?: string;
}) {
    const { siteSection, ...iconProps } = props;
    return siteSection.icon ? (
        <ContentIcon icon={siteSection.icon as FAIconName} {...iconProps} />
    ) : (
        <Icon.SiteSection {...iconProps} />
    );
}
